import { Button, Col, Form, Input, message, Row, Select } from 'antd';
import React, { useState } from 'react';
import { SupportManagerContainer } from '../supportManager.styles';
import TextArea from 'antd/es/input/TextArea';

const categoryData = [
    { id: 1, name: 'Billing' },
    { id: 2, name: 'AOis' },
    { id: 3, name: 'Data' },
    { id: 4, name: 'Uploads' }
];

interface SupportDetailProps {
    onCancel: () => void;
}

const SupportDetails = ({ onCancel }: SupportDetailProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const handleSupportDetails = (values: any) => {
        setLoading(true)
        console.log('Form values:', values);
        message.success('Form submitted successfully!');
        setLoading(false);
    };

    React.useEffect(() => {
        form.setFieldsValue({
            category: categoryData[0].id,
        });
    }, [form]);

    return (
        <SupportManagerContainer>
            <div className='billing_block'>
                <Form form={form} onFinish={handleSupportDetails}>
                    <div className='form_block'>
                        <Row gutter={[20, 20]}>
                            <Col xs={24} sm={24} md={14} lg={14} xl={12}>
                                <Row gutter={[20, 20]} className='project_input_row'>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                                        <label>Email Address</label>
                                    </Col>
                                    <Col xs={24} sm={24} md={16} lg={16} xl={18} className='project_input_column'>
                                        <Form.Item
                                            name="name"
                                            className='form_input_item'
                                            rules={[{ required: true, message: 'Please enter your email!' }]}
                                        >
                                            <Input type="email" placeholder="Email" className="conversionName" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[20, 20]} className='project_input_row'>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                                        <label>Category</label>
                                    </Col>
                                    <Col xs={24} sm={24} md={16} lg={16} xl={18} className='project_input_column'>
                                        <Form.Item
                                            name="category"
                                            className='form_input_item'
                                            rules={[{ required: true, message: 'Please select a category!' }]}
                                        >
                                            <Select
                                                showSearch
                                                style={{ width: '100%' }}
                                                placeholder="Search.."
                                                optionFilterProp="children"
                                                className='permission_select'
                                                defaultValue={categoryData[0].id}
                                            >
                                                {categoryData.map(item => (
                                                    <Select.Option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Form.Item
                            name="message"
                            className='textarea_input'
                            rules={[{ required: true, message: 'Please write a message!' }]}
                        >
                            <TextArea
                                className='support_textarea'
                                placeholder="Write a message"
                                autoSize={{ minRows: 5, maxRows: 5 }}
                            />
                        </Form.Item>
                    </div>
                    <div className='footer_box'>
                        <div className='footer_inner_box'>
                            <Button htmlType='submit' className='footer_btn footer_btn_save' loading={loading}>Submit</Button>
                            <Button className='footer_btn footer_btn_cancel' onClick={() => onCancel()}>Cancel</Button>
                        </div>
                    </div>
                </Form>
            </div>
        </SupportManagerContainer>
    );
}

export default SupportDetails;
